import { pickBy } from 'lodash';
import queryString from 'query-string';

export const skipEmptyStrings = (query) =>
  Object.keys(query)
    .filter((k) => query[k] !== '')
    .reduce((a, k) => ({ ...a, [k]: query[k] }), {});

export const addQueryParams = ({ navigate, location }, newParams) => {
  const currentParams = queryString.parse(location?.search);
  const mergedParams = { ...currentParams, ...newParams };

  const filteredParams = pickBy(mergedParams, (value) => {
    return (
      value !== undefined &&
      value !== null &&
      value !== '' &&
      !Number.isNaN(value)
    );
  });

  navigate({
    search: queryString.stringify(filteredParams),
    pathname: window.location.pathname,
  });
};
